//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase, HttpContext } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ICalendarClient {
    getCalendar(): Observable<CalendarDto>;
    getAll(): Observable<Calendar[]>;
    get(id: string): Observable<Calendar>;
}

@Injectable({
    providedIn: 'root'
})
export class CalendarClient implements ICalendarClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCalendar(httpContext?: HttpContext): Observable<CalendarDto> {
        let url_ = this.baseUrl + "/odata/Calendar/get-calendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarDto>;
        }));
    }

    protected processGetCalendar(response: HttpResponseBase): Observable<CalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarDto>(null as any);
    }

    getAll(httpContext?: HttpContext): Observable<Calendar[]> {
        let url_ = this.baseUrl + "/odata/Calendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Calendar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Calendar[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Calendar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Calendar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Calendar[]>(null as any);
    }

    get(id: string, httpContext?: HttpContext): Observable<Calendar> {
        let url_ = this.baseUrl + "/odata/Calendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Calendar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Calendar>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Calendar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Calendar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Calendar>(null as any);
    }
}

export interface IConfidenceClient {
    getAll(): Observable<Confidence[]>;
    get(id: number): Observable<Confidence>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfidenceClient implements IConfidenceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<Confidence[]> {
        let url_ = this.baseUrl + "/odata/Confidence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Confidence[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Confidence[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Confidence[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Confidence.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Confidence[]>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<Confidence> {
        let url_ = this.baseUrl + "/odata/Confidence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Confidence>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Confidence>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Confidence> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Confidence.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Confidence>(null as any);
    }
}

export interface IContractedEmployeeClient {
    getAll(): Observable<ContractedEmployeeDto[]>;
    update(contractedEmployeeDto: ContractedEmployeeDto): Observable<ContractedEmployeeDto>;
    get(id: number): Observable<ContractedEmployeeDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractedEmployeeClient implements IContractedEmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<ContractedEmployeeDto[]> {
        let url_ = this.baseUrl + "/odata/ContractedEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedEmployeeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractedEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractedEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedEmployeeDto[]>(null as any);
    }

    update(contractedEmployeeDto: ContractedEmployeeDto, httpContext?: HttpContext): Observable<ContractedEmployeeDto> {
        let url_ = this.baseUrl + "/odata/ContractedEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contractedEmployeeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedEmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedEmployeeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContractedEmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractedEmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedEmployeeDto>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<ContractedEmployeeDto> {
        let url_ = this.baseUrl + "/odata/ContractedEmployee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedEmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedEmployeeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractedEmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractedEmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedEmployeeDto>(null as any);
    }
}

export interface IContractedProjectClient {
    getAll(): Observable<ContractedProjectDto[]>;
    update(contractedProjectDto: ContractedProjectDto): Observable<ContractedProjectDto>;
    get(id: number): Observable<ContractedProjectDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractedProjectClient implements IContractedProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<ContractedProjectDto[]> {
        let url_ = this.baseUrl + "/odata/ContractedProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedProjectDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractedProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractedProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedProjectDto[]>(null as any);
    }

    update(contractedProjectDto: ContractedProjectDto, httpContext?: HttpContext): Observable<ContractedProjectDto> {
        let url_ = this.baseUrl + "/odata/ContractedProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contractedProjectDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedProjectDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContractedProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractedProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedProjectDto>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<ContractedProjectDto> {
        let url_ = this.baseUrl + "/odata/ContractedProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractedProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractedProjectDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractedProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractedProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractedProjectDto>(null as any);
    }
}

export interface IEmployeeClient {
    getAll(): Observable<Employee[]>;
    get(id: number): Observable<Employee>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient implements IEmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<Employee[]> {
        let url_ = this.baseUrl + "/odata/Employee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee[]>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<Employee> {
        let url_ = this.baseUrl + "/odata/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee>(null as any);
    }
}

export interface IProjectClient {
    getAll(): Observable<Project[]>;
    get(id: string): Observable<Project>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectClient implements IProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<Project[]> {
        let url_ = this.baseUrl + "/odata/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Project[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Project[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Project[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Project[]>(null as any);
    }

    get(id: string, httpContext?: HttpContext): Observable<Project> {
        let url_ = this.baseUrl + "/odata/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Project>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Project>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Project> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Project.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Project>(null as any);
    }
}

export interface IProjectDevOps2PortalClient {
    getAll(): Observable<ProjectDevOps2Portal[]>;
    get(id: number): Observable<ProjectDevOps2Portal>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectDevOps2PortalClient implements IProjectDevOps2PortalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<ProjectDevOps2Portal[]> {
        let url_ = this.baseUrl + "/odata/ProjectDevOps2Portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDevOps2Portal[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDevOps2Portal[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProjectDevOps2Portal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDevOps2Portal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDevOps2Portal[]>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<ProjectDevOps2Portal> {
        let url_ = this.baseUrl + "/odata/ProjectDevOps2Portal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDevOps2Portal>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDevOps2Portal>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectDevOps2Portal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDevOps2Portal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDevOps2Portal>(null as any);
    }
}

export interface IRollingContractClient {
    getAll(): Observable<RollingContractDto[]>;
    update(contractDto: RollingContractDto): Observable<RollingContractDto>;
    create(createRollingContractDto: CreateRollingContractDto): Observable<RollingContractDto>;
    fillTillEndOfMonth(rollingContract: RollingContractDto | undefined, value: number | null | undefined, calendarId: string | null | undefined): Observable<RollingContractDto>;
    get(id: number): Observable<RollingContractDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RollingContractClient implements IRollingContractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(httpContext?: HttpContext): Observable<RollingContractDto[]> {
        let url_ = this.baseUrl + "/odata/RollingContract";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RollingContractDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RollingContractDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RollingContractDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RollingContractDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RollingContractDto[]>(null as any);
    }

    update(contractDto: RollingContractDto, httpContext?: HttpContext): Observable<RollingContractDto> {
        let url_ = this.baseUrl + "/odata/RollingContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contractDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RollingContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RollingContractDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RollingContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RollingContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RollingContractDto>(null as any);
    }

    create(createRollingContractDto: CreateRollingContractDto, httpContext?: HttpContext): Observable<RollingContractDto> {
        let url_ = this.baseUrl + "/odata/RollingContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRollingContractDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RollingContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RollingContractDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RollingContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RollingContractDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RollingContractDto>(null as any);
    }

    fillTillEndOfMonth(rollingContract: RollingContractDto | undefined, value: number | null | undefined, calendarId: string | null | undefined, httpContext?: HttpContext): Observable<RollingContractDto> {
        let url_ = this.baseUrl + "/odata/RollingContract/fill-till-end-of-month?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (calendarId !== undefined && calendarId !== null)
            url_ += "calendarId=" + encodeURIComponent("" + calendarId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rollingContract);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillTillEndOfMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillTillEndOfMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RollingContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RollingContractDto>;
        }));
    }

    protected processFillTillEndOfMonth(response: HttpResponseBase): Observable<RollingContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RollingContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RollingContractDto>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<RollingContractDto> {
        let url_ = this.baseUrl + "/odata/RollingContract/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RollingContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RollingContractDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RollingContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RollingContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RollingContractDto>(null as any);
    }
}

export interface ITeamClient {
    getAllTeams(): Observable<TeamDto[]>;
    getAll(): Observable<TeamDto[]>;
    get(id: number): Observable<TeamDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TeamClient implements ITeamClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllTeams(httpContext?: HttpContext): Observable<TeamDto[]> {
        let url_ = this.baseUrl + "/odata/Team/get-teams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamDto[]>;
        }));
    }

    protected processGetAllTeams(response: HttpResponseBase): Observable<TeamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeamDto[]>(null as any);
    }

    getAll(httpContext?: HttpContext): Observable<TeamDto[]> {
        let url_ = this.baseUrl + "/odata/Team";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TeamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeamDto[]>(null as any);
    }

    get(id: number, httpContext?: HttpContext): Observable<TeamDto> {
        let url_ = this.baseUrl + "/odata/Team/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TeamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeamDto>(null as any);
    }
}

export class CalendarDto implements ICalendarDto {
    weeks?: WeekDto[] | undefined;
    currentWeekNumber!: number;
    yearsRange?: number[] | undefined;

    constructor(data?: ICalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [] as any;
                for (let item of _data["weeks"])
                    this.weeks!.push(WeekDto.fromJS(item));
            }
            this.currentWeekNumber = _data["currentWeekNumber"];
            if (Array.isArray(_data["yearsRange"])) {
                this.yearsRange = [] as any;
                for (let item of _data["yearsRange"])
                    this.yearsRange!.push(item);
            }
        }
    }

    static fromJS(data: any): CalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (let item of this.weeks)
                data["weeks"].push(item.toJSON());
        }
        data["currentWeekNumber"] = this.currentWeekNumber;
        if (Array.isArray(this.yearsRange)) {
            data["yearsRange"] = [];
            for (let item of this.yearsRange)
                data["yearsRange"].push(item);
        }
        return data;
    }
}

export interface ICalendarDto {
    weeks?: WeekDto[] | undefined;
    currentWeekNumber: number;
    yearsRange?: number[] | undefined;
}

export class WeekDto implements IWeekDto {
    id!: string;
    name?: string | undefined;
    startsAt!: Date;
    dateNo!: number;
    dateStartYear!: number;

    constructor(data?: IWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startsAt = _data["startsAt"] ? new Date(_data["startsAt"].toString()) : <any>undefined;
            this.dateNo = _data["dateNo"];
            this.dateStartYear = _data["dateStartYear"];
        }
    }

    static fromJS(data: any): WeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startsAt"] = this.startsAt ? this.startsAt.toISOString() : <any>undefined;
        data["dateNo"] = this.dateNo;
        data["dateStartYear"] = this.dateStartYear;
        return data;
    }
}

export interface IWeekDto {
    id: string;
    name?: string | undefined;
    startsAt: Date;
    dateNo: number;
    dateStartYear: number;
}

export abstract class EntityBaseOfString implements IEntityBaseOfString {
    id!: string;

    constructor(data?: IEntityBaseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfString {
    id: string;
}

export class Calendar extends EntityBaseOfString implements ICalendar {
    name!: string;
    type!: string;
    dateNo!: number;
    dateStart!: Date;
    dateEnd!: Date;
    dateStartMonth!: number;
    dateStartYear!: number;

    constructor(data?: ICalendar) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.dateNo = _data["dateNo"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.dateStartMonth = _data["dateStartMonth"];
            this.dateStartYear = _data["dateStartYear"];
        }
    }

    static override fromJS(data: any): Calendar {
        data = typeof data === 'object' ? data : {};
        let result = new Calendar();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["dateNo"] = this.dateNo;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["dateStartMonth"] = this.dateStartMonth;
        data["dateStartYear"] = this.dateStartYear;
        super.toJSON(data);
        return data;
    }
}

export interface ICalendar extends IEntityBaseOfString {
    name: string;
    type: string;
    dateNo: number;
    dateStart: Date;
    dateEnd: Date;
    dateStartMonth: number;
    dateStartYear: number;
}

export abstract class EntityBaseOfShort implements IEntityBaseOfShort {
    id!: number;

    constructor(data?: IEntityBaseOfShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfShort {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfShort' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfShort {
    id: number;
}

export class Confidence extends EntityBaseOfShort implements IConfidence {
    symbol?: string | undefined;
    name?: string | undefined;

    constructor(data?: IConfidence) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.symbol = _data["symbol"];
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): Confidence {
        data = typeof data === 'object' ? data : {};
        let result = new Confidence();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IConfidence extends IEntityBaseOfShort {
    symbol?: string | undefined;
    name?: string | undefined;
}

export class ContractedEmployeeDto implements IContractedEmployeeDto {
    id!: number;
    employeeName?: string | undefined;
    employeeType?: string | undefined;
    year?: string | undefined;
    isVisible!: boolean;
    isContracted!: boolean;
    w01?: string | undefined;
    w02?: string | undefined;
    w03?: string | undefined;
    w04?: string | undefined;
    w05?: string | undefined;
    w06?: string | undefined;
    w07?: string | undefined;
    w08?: string | undefined;
    w09?: string | undefined;
    w10?: string | undefined;
    w11?: string | undefined;
    w12?: string | undefined;
    w13?: string | undefined;
    w14?: string | undefined;
    w15?: string | undefined;
    w16?: string | undefined;
    w17?: string | undefined;
    w18?: string | undefined;
    w19?: string | undefined;
    w20?: string | undefined;
    w21?: string | undefined;
    w22?: string | undefined;
    w23?: string | undefined;
    w24?: string | undefined;
    w25?: string | undefined;
    w26?: string | undefined;
    w27?: string | undefined;
    w28?: string | undefined;
    w29?: string | undefined;
    w30?: string | undefined;
    w31?: string | undefined;
    w32?: string | undefined;
    w33?: string | undefined;
    w34?: string | undefined;
    w35?: string | undefined;
    w36?: string | undefined;
    w37?: string | undefined;
    w38?: string | undefined;
    w39?: string | undefined;
    w40?: string | undefined;
    w41?: string | undefined;
    w42?: string | undefined;
    w43?: string | undefined;
    w44?: string | undefined;
    w45?: string | undefined;
    w46?: string | undefined;
    w47?: string | undefined;
    w48?: string | undefined;
    w49?: string | undefined;
    w50?: string | undefined;
    w51?: string | undefined;
    w52?: string | undefined;
    w53?: string | undefined;

    constructor(data?: IContractedEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeName = _data["employeeName"];
            this.employeeType = _data["employeeType"];
            this.year = _data["year"];
            this.isVisible = _data["isVisible"];
            this.isContracted = _data["isContracted"];
            this.w01 = _data["w01"];
            this.w02 = _data["w02"];
            this.w03 = _data["w03"];
            this.w04 = _data["w04"];
            this.w05 = _data["w05"];
            this.w06 = _data["w06"];
            this.w07 = _data["w07"];
            this.w08 = _data["w08"];
            this.w09 = _data["w09"];
            this.w10 = _data["w10"];
            this.w11 = _data["w11"];
            this.w12 = _data["w12"];
            this.w13 = _data["w13"];
            this.w14 = _data["w14"];
            this.w15 = _data["w15"];
            this.w16 = _data["w16"];
            this.w17 = _data["w17"];
            this.w18 = _data["w18"];
            this.w19 = _data["w19"];
            this.w20 = _data["w20"];
            this.w21 = _data["w21"];
            this.w22 = _data["w22"];
            this.w23 = _data["w23"];
            this.w24 = _data["w24"];
            this.w25 = _data["w25"];
            this.w26 = _data["w26"];
            this.w27 = _data["w27"];
            this.w28 = _data["w28"];
            this.w29 = _data["w29"];
            this.w30 = _data["w30"];
            this.w31 = _data["w31"];
            this.w32 = _data["w32"];
            this.w33 = _data["w33"];
            this.w34 = _data["w34"];
            this.w35 = _data["w35"];
            this.w36 = _data["w36"];
            this.w37 = _data["w37"];
            this.w38 = _data["w38"];
            this.w39 = _data["w39"];
            this.w40 = _data["w40"];
            this.w41 = _data["w41"];
            this.w42 = _data["w42"];
            this.w43 = _data["w43"];
            this.w44 = _data["w44"];
            this.w45 = _data["w45"];
            this.w46 = _data["w46"];
            this.w47 = _data["w47"];
            this.w48 = _data["w48"];
            this.w49 = _data["w49"];
            this.w50 = _data["w50"];
            this.w51 = _data["w51"];
            this.w52 = _data["w52"];
            this.w53 = _data["w53"];
        }
    }

    static fromJS(data: any): ContractedEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractedEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeName"] = this.employeeName;
        data["employeeType"] = this.employeeType;
        data["year"] = this.year;
        data["isVisible"] = this.isVisible;
        data["isContracted"] = this.isContracted;
        data["w01"] = this.w01;
        data["w02"] = this.w02;
        data["w03"] = this.w03;
        data["w04"] = this.w04;
        data["w05"] = this.w05;
        data["w06"] = this.w06;
        data["w07"] = this.w07;
        data["w08"] = this.w08;
        data["w09"] = this.w09;
        data["w10"] = this.w10;
        data["w11"] = this.w11;
        data["w12"] = this.w12;
        data["w13"] = this.w13;
        data["w14"] = this.w14;
        data["w15"] = this.w15;
        data["w16"] = this.w16;
        data["w17"] = this.w17;
        data["w18"] = this.w18;
        data["w19"] = this.w19;
        data["w20"] = this.w20;
        data["w21"] = this.w21;
        data["w22"] = this.w22;
        data["w23"] = this.w23;
        data["w24"] = this.w24;
        data["w25"] = this.w25;
        data["w26"] = this.w26;
        data["w27"] = this.w27;
        data["w28"] = this.w28;
        data["w29"] = this.w29;
        data["w30"] = this.w30;
        data["w31"] = this.w31;
        data["w32"] = this.w32;
        data["w33"] = this.w33;
        data["w34"] = this.w34;
        data["w35"] = this.w35;
        data["w36"] = this.w36;
        data["w37"] = this.w37;
        data["w38"] = this.w38;
        data["w39"] = this.w39;
        data["w40"] = this.w40;
        data["w41"] = this.w41;
        data["w42"] = this.w42;
        data["w43"] = this.w43;
        data["w44"] = this.w44;
        data["w45"] = this.w45;
        data["w46"] = this.w46;
        data["w47"] = this.w47;
        data["w48"] = this.w48;
        data["w49"] = this.w49;
        data["w50"] = this.w50;
        data["w51"] = this.w51;
        data["w52"] = this.w52;
        data["w53"] = this.w53;
        return data;
    }
}

export interface IContractedEmployeeDto {
    id: number;
    employeeName?: string | undefined;
    employeeType?: string | undefined;
    year?: string | undefined;
    isVisible: boolean;
    isContracted: boolean;
    w01?: string | undefined;
    w02?: string | undefined;
    w03?: string | undefined;
    w04?: string | undefined;
    w05?: string | undefined;
    w06?: string | undefined;
    w07?: string | undefined;
    w08?: string | undefined;
    w09?: string | undefined;
    w10?: string | undefined;
    w11?: string | undefined;
    w12?: string | undefined;
    w13?: string | undefined;
    w14?: string | undefined;
    w15?: string | undefined;
    w16?: string | undefined;
    w17?: string | undefined;
    w18?: string | undefined;
    w19?: string | undefined;
    w20?: string | undefined;
    w21?: string | undefined;
    w22?: string | undefined;
    w23?: string | undefined;
    w24?: string | undefined;
    w25?: string | undefined;
    w26?: string | undefined;
    w27?: string | undefined;
    w28?: string | undefined;
    w29?: string | undefined;
    w30?: string | undefined;
    w31?: string | undefined;
    w32?: string | undefined;
    w33?: string | undefined;
    w34?: string | undefined;
    w35?: string | undefined;
    w36?: string | undefined;
    w37?: string | undefined;
    w38?: string | undefined;
    w39?: string | undefined;
    w40?: string | undefined;
    w41?: string | undefined;
    w42?: string | undefined;
    w43?: string | undefined;
    w44?: string | undefined;
    w45?: string | undefined;
    w46?: string | undefined;
    w47?: string | undefined;
    w48?: string | undefined;
    w49?: string | undefined;
    w50?: string | undefined;
    w51?: string | undefined;
    w52?: string | undefined;
    w53?: string | undefined;
}

export class ContractedProjectDto implements IContractedProjectDto {
    id?: number | undefined;
    projectName?: string | undefined;
    year?: string | undefined;
    isContracted!: boolean;
    isVisible!: boolean;
    w01?: string | undefined;
    w02?: string | undefined;
    w03?: string | undefined;
    w04?: string | undefined;
    w05?: string | undefined;
    w06?: string | undefined;
    w07?: string | undefined;
    w08?: string | undefined;
    w09?: string | undefined;
    w10?: string | undefined;
    w11?: string | undefined;
    w12?: string | undefined;
    w13?: string | undefined;
    w14?: string | undefined;
    w15?: string | undefined;
    w16?: string | undefined;
    w17?: string | undefined;
    w18?: string | undefined;
    w19?: string | undefined;
    w20?: string | undefined;
    w21?: string | undefined;
    w22?: string | undefined;
    w23?: string | undefined;
    w24?: string | undefined;
    w25?: string | undefined;
    w26?: string | undefined;
    w27?: string | undefined;
    w28?: string | undefined;
    w29?: string | undefined;
    w30?: string | undefined;
    w31?: string | undefined;
    w32?: string | undefined;
    w33?: string | undefined;
    w34?: string | undefined;
    w35?: string | undefined;
    w36?: string | undefined;
    w37?: string | undefined;
    w38?: string | undefined;
    w39?: string | undefined;
    w40?: string | undefined;
    w41?: string | undefined;
    w42?: string | undefined;
    w43?: string | undefined;
    w44?: string | undefined;
    w45?: string | undefined;
    w46?: string | undefined;
    w47?: string | undefined;
    w48?: string | undefined;
    w49?: string | undefined;
    w50?: string | undefined;
    w51?: string | undefined;
    w52?: string | undefined;
    w53?: string | undefined;

    constructor(data?: IContractedProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.year = _data["year"];
            this.isContracted = _data["isContracted"];
            this.isVisible = _data["isVisible"];
            this.w01 = _data["w01"];
            this.w02 = _data["w02"];
            this.w03 = _data["w03"];
            this.w04 = _data["w04"];
            this.w05 = _data["w05"];
            this.w06 = _data["w06"];
            this.w07 = _data["w07"];
            this.w08 = _data["w08"];
            this.w09 = _data["w09"];
            this.w10 = _data["w10"];
            this.w11 = _data["w11"];
            this.w12 = _data["w12"];
            this.w13 = _data["w13"];
            this.w14 = _data["w14"];
            this.w15 = _data["w15"];
            this.w16 = _data["w16"];
            this.w17 = _data["w17"];
            this.w18 = _data["w18"];
            this.w19 = _data["w19"];
            this.w20 = _data["w20"];
            this.w21 = _data["w21"];
            this.w22 = _data["w22"];
            this.w23 = _data["w23"];
            this.w24 = _data["w24"];
            this.w25 = _data["w25"];
            this.w26 = _data["w26"];
            this.w27 = _data["w27"];
            this.w28 = _data["w28"];
            this.w29 = _data["w29"];
            this.w30 = _data["w30"];
            this.w31 = _data["w31"];
            this.w32 = _data["w32"];
            this.w33 = _data["w33"];
            this.w34 = _data["w34"];
            this.w35 = _data["w35"];
            this.w36 = _data["w36"];
            this.w37 = _data["w37"];
            this.w38 = _data["w38"];
            this.w39 = _data["w39"];
            this.w40 = _data["w40"];
            this.w41 = _data["w41"];
            this.w42 = _data["w42"];
            this.w43 = _data["w43"];
            this.w44 = _data["w44"];
            this.w45 = _data["w45"];
            this.w46 = _data["w46"];
            this.w47 = _data["w47"];
            this.w48 = _data["w48"];
            this.w49 = _data["w49"];
            this.w50 = _data["w50"];
            this.w51 = _data["w51"];
            this.w52 = _data["w52"];
            this.w53 = _data["w53"];
        }
    }

    static fromJS(data: any): ContractedProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractedProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["year"] = this.year;
        data["isContracted"] = this.isContracted;
        data["isVisible"] = this.isVisible;
        data["w01"] = this.w01;
        data["w02"] = this.w02;
        data["w03"] = this.w03;
        data["w04"] = this.w04;
        data["w05"] = this.w05;
        data["w06"] = this.w06;
        data["w07"] = this.w07;
        data["w08"] = this.w08;
        data["w09"] = this.w09;
        data["w10"] = this.w10;
        data["w11"] = this.w11;
        data["w12"] = this.w12;
        data["w13"] = this.w13;
        data["w14"] = this.w14;
        data["w15"] = this.w15;
        data["w16"] = this.w16;
        data["w17"] = this.w17;
        data["w18"] = this.w18;
        data["w19"] = this.w19;
        data["w20"] = this.w20;
        data["w21"] = this.w21;
        data["w22"] = this.w22;
        data["w23"] = this.w23;
        data["w24"] = this.w24;
        data["w25"] = this.w25;
        data["w26"] = this.w26;
        data["w27"] = this.w27;
        data["w28"] = this.w28;
        data["w29"] = this.w29;
        data["w30"] = this.w30;
        data["w31"] = this.w31;
        data["w32"] = this.w32;
        data["w33"] = this.w33;
        data["w34"] = this.w34;
        data["w35"] = this.w35;
        data["w36"] = this.w36;
        data["w37"] = this.w37;
        data["w38"] = this.w38;
        data["w39"] = this.w39;
        data["w40"] = this.w40;
        data["w41"] = this.w41;
        data["w42"] = this.w42;
        data["w43"] = this.w43;
        data["w44"] = this.w44;
        data["w45"] = this.w45;
        data["w46"] = this.w46;
        data["w47"] = this.w47;
        data["w48"] = this.w48;
        data["w49"] = this.w49;
        data["w50"] = this.w50;
        data["w51"] = this.w51;
        data["w52"] = this.w52;
        data["w53"] = this.w53;
        return data;
    }
}

export interface IContractedProjectDto {
    id?: number | undefined;
    projectName?: string | undefined;
    year?: string | undefined;
    isContracted: boolean;
    isVisible: boolean;
    w01?: string | undefined;
    w02?: string | undefined;
    w03?: string | undefined;
    w04?: string | undefined;
    w05?: string | undefined;
    w06?: string | undefined;
    w07?: string | undefined;
    w08?: string | undefined;
    w09?: string | undefined;
    w10?: string | undefined;
    w11?: string | undefined;
    w12?: string | undefined;
    w13?: string | undefined;
    w14?: string | undefined;
    w15?: string | undefined;
    w16?: string | undefined;
    w17?: string | undefined;
    w18?: string | undefined;
    w19?: string | undefined;
    w20?: string | undefined;
    w21?: string | undefined;
    w22?: string | undefined;
    w23?: string | undefined;
    w24?: string | undefined;
    w25?: string | undefined;
    w26?: string | undefined;
    w27?: string | undefined;
    w28?: string | undefined;
    w29?: string | undefined;
    w30?: string | undefined;
    w31?: string | undefined;
    w32?: string | undefined;
    w33?: string | undefined;
    w34?: string | undefined;
    w35?: string | undefined;
    w36?: string | undefined;
    w37?: string | undefined;
    w38?: string | undefined;
    w39?: string | undefined;
    w40?: string | undefined;
    w41?: string | undefined;
    w42?: string | undefined;
    w43?: string | undefined;
    w44?: string | undefined;
    w45?: string | undefined;
    w46?: string | undefined;
    w47?: string | undefined;
    w48?: string | undefined;
    w49?: string | undefined;
    w50?: string | undefined;
    w51?: string | undefined;
    w52?: string | undefined;
    w53?: string | undefined;
}

export abstract class EntityBaseOfInteger implements IEntityBaseOfInteger {
    id!: number;

    constructor(data?: IEntityBaseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfInteger {
    id: number;
}

export class Employee extends EntityBaseOfInteger implements IEmployee {
    code!: string;
    lastName!: string;
    firstName!: string;
    employmentStatus?: string | undefined;
    employeeType?: string | undefined;

    constructor(data?: IEmployee) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.employmentStatus = _data["employmentStatus"];
            this.employeeType = _data["employeeType"];
        }
    }

    static override fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["employmentStatus"] = this.employmentStatus;
        data["employeeType"] = this.employeeType;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployee extends IEntityBaseOfInteger {
    code: string;
    lastName: string;
    firstName: string;
    employmentStatus?: string | undefined;
    employeeType?: string | undefined;
}

export abstract class EntityBaseOfGuid implements IEntityBaseOfGuid {
    id!: string;

    constructor(data?: IEntityBaseOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfGuid {
    id: string;
}

export class Project extends EntityBaseOfGuid implements IProject {
    id!: string;
    name?: string | undefined;
    status?: number | undefined;
    enova?: string | undefined;

    constructor(data?: IProject) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.enova = _data["enova"];
        }
    }

    static override fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["enova"] = this.enova;
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IEntityBaseOfGuid {
    id: string;
    name?: string | undefined;
    status?: number | undefined;
    enova?: string | undefined;
}

export class ProjectDevOps2Portal extends EntityBaseOfInteger implements IProjectDevOps2Portal {
    devOpsProjectId?: string | undefined;
    portalWorkProjectId?: number | undefined;

    constructor(data?: IProjectDevOps2Portal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.devOpsProjectId = _data["devOpsProjectId"];
            this.portalWorkProjectId = _data["portalWorkProjectId"];
        }
    }

    static override fromJS(data: any): ProjectDevOps2Portal {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDevOps2Portal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["devOpsProjectId"] = this.devOpsProjectId;
        data["portalWorkProjectId"] = this.portalWorkProjectId;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDevOps2Portal extends IEntityBaseOfInteger {
    devOpsProjectId?: string | undefined;
    portalWorkProjectId?: number | undefined;
}

export class RollingContractDto implements IRollingContractDto {
    id?: number | undefined;
    summary!: number;
    opportunityName?: string | undefined;
    projectName?: string | undefined;
    teamSymbol?: string | undefined;
    employeeName?: string | undefined;
    isVisible?: boolean | undefined;
    confidenceSymbol?: string | undefined;
    year?: string | undefined;
    w01?: number | undefined;
    w02?: number | undefined;
    w03?: number | undefined;
    w04?: number | undefined;
    w05?: number | undefined;
    w06?: number | undefined;
    w07?: number | undefined;
    w08?: number | undefined;
    w09?: number | undefined;
    w10?: number | undefined;
    w11?: number | undefined;
    w12?: number | undefined;
    w13?: number | undefined;
    w14?: number | undefined;
    w15?: number | undefined;
    w16?: number | undefined;
    w17?: number | undefined;
    w18?: number | undefined;
    w19?: number | undefined;
    w20?: number | undefined;
    w21?: number | undefined;
    w22?: number | undefined;
    w23?: number | undefined;
    w24?: number | undefined;
    w25?: number | undefined;
    w26?: number | undefined;
    w27?: number | undefined;
    w28?: number | undefined;
    w29?: number | undefined;
    w30?: number | undefined;
    w31?: number | undefined;
    w32?: number | undefined;
    w33?: number | undefined;
    w34?: number | undefined;
    w35?: number | undefined;
    w36?: number | undefined;
    w37?: number | undefined;
    w38?: number | undefined;
    w39?: number | undefined;
    w40?: number | undefined;
    w41?: number | undefined;
    w42?: number | undefined;
    w43?: number | undefined;
    w44?: number | undefined;
    w45?: number | undefined;
    w46?: number | undefined;
    w47?: number | undefined;
    w48?: number | undefined;
    w49?: number | undefined;
    w50?: number | undefined;
    w51?: number | undefined;
    w52?: number | undefined;
    w53?: number | undefined;

    constructor(data?: IRollingContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.summary = _data["summary"];
            this.opportunityName = _data["opportunityName"];
            this.projectName = _data["projectName"];
            this.teamSymbol = _data["teamSymbol"];
            this.employeeName = _data["employeeName"];
            this.isVisible = _data["isVisible"];
            this.confidenceSymbol = _data["confidenceSymbol"];
            this.year = _data["year"];
            this.w01 = _data["w01"];
            this.w02 = _data["w02"];
            this.w03 = _data["w03"];
            this.w04 = _data["w04"];
            this.w05 = _data["w05"];
            this.w06 = _data["w06"];
            this.w07 = _data["w07"];
            this.w08 = _data["w08"];
            this.w09 = _data["w09"];
            this.w10 = _data["w10"];
            this.w11 = _data["w11"];
            this.w12 = _data["w12"];
            this.w13 = _data["w13"];
            this.w14 = _data["w14"];
            this.w15 = _data["w15"];
            this.w16 = _data["w16"];
            this.w17 = _data["w17"];
            this.w18 = _data["w18"];
            this.w19 = _data["w19"];
            this.w20 = _data["w20"];
            this.w21 = _data["w21"];
            this.w22 = _data["w22"];
            this.w23 = _data["w23"];
            this.w24 = _data["w24"];
            this.w25 = _data["w25"];
            this.w26 = _data["w26"];
            this.w27 = _data["w27"];
            this.w28 = _data["w28"];
            this.w29 = _data["w29"];
            this.w30 = _data["w30"];
            this.w31 = _data["w31"];
            this.w32 = _data["w32"];
            this.w33 = _data["w33"];
            this.w34 = _data["w34"];
            this.w35 = _data["w35"];
            this.w36 = _data["w36"];
            this.w37 = _data["w37"];
            this.w38 = _data["w38"];
            this.w39 = _data["w39"];
            this.w40 = _data["w40"];
            this.w41 = _data["w41"];
            this.w42 = _data["w42"];
            this.w43 = _data["w43"];
            this.w44 = _data["w44"];
            this.w45 = _data["w45"];
            this.w46 = _data["w46"];
            this.w47 = _data["w47"];
            this.w48 = _data["w48"];
            this.w49 = _data["w49"];
            this.w50 = _data["w50"];
            this.w51 = _data["w51"];
            this.w52 = _data["w52"];
            this.w53 = _data["w53"];
        }
    }

    static fromJS(data: any): RollingContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new RollingContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["summary"] = this.summary;
        data["opportunityName"] = this.opportunityName;
        data["projectName"] = this.projectName;
        data["teamSymbol"] = this.teamSymbol;
        data["employeeName"] = this.employeeName;
        data["isVisible"] = this.isVisible;
        data["confidenceSymbol"] = this.confidenceSymbol;
        data["year"] = this.year;
        data["w01"] = this.w01;
        data["w02"] = this.w02;
        data["w03"] = this.w03;
        data["w04"] = this.w04;
        data["w05"] = this.w05;
        data["w06"] = this.w06;
        data["w07"] = this.w07;
        data["w08"] = this.w08;
        data["w09"] = this.w09;
        data["w10"] = this.w10;
        data["w11"] = this.w11;
        data["w12"] = this.w12;
        data["w13"] = this.w13;
        data["w14"] = this.w14;
        data["w15"] = this.w15;
        data["w16"] = this.w16;
        data["w17"] = this.w17;
        data["w18"] = this.w18;
        data["w19"] = this.w19;
        data["w20"] = this.w20;
        data["w21"] = this.w21;
        data["w22"] = this.w22;
        data["w23"] = this.w23;
        data["w24"] = this.w24;
        data["w25"] = this.w25;
        data["w26"] = this.w26;
        data["w27"] = this.w27;
        data["w28"] = this.w28;
        data["w29"] = this.w29;
        data["w30"] = this.w30;
        data["w31"] = this.w31;
        data["w32"] = this.w32;
        data["w33"] = this.w33;
        data["w34"] = this.w34;
        data["w35"] = this.w35;
        data["w36"] = this.w36;
        data["w37"] = this.w37;
        data["w38"] = this.w38;
        data["w39"] = this.w39;
        data["w40"] = this.w40;
        data["w41"] = this.w41;
        data["w42"] = this.w42;
        data["w43"] = this.w43;
        data["w44"] = this.w44;
        data["w45"] = this.w45;
        data["w46"] = this.w46;
        data["w47"] = this.w47;
        data["w48"] = this.w48;
        data["w49"] = this.w49;
        data["w50"] = this.w50;
        data["w51"] = this.w51;
        data["w52"] = this.w52;
        data["w53"] = this.w53;
        return data;
    }
}

export interface IRollingContractDto {
    id?: number | undefined;
    summary: number;
    opportunityName?: string | undefined;
    projectName?: string | undefined;
    teamSymbol?: string | undefined;
    employeeName?: string | undefined;
    isVisible?: boolean | undefined;
    confidenceSymbol?: string | undefined;
    year?: string | undefined;
    w01?: number | undefined;
    w02?: number | undefined;
    w03?: number | undefined;
    w04?: number | undefined;
    w05?: number | undefined;
    w06?: number | undefined;
    w07?: number | undefined;
    w08?: number | undefined;
    w09?: number | undefined;
    w10?: number | undefined;
    w11?: number | undefined;
    w12?: number | undefined;
    w13?: number | undefined;
    w14?: number | undefined;
    w15?: number | undefined;
    w16?: number | undefined;
    w17?: number | undefined;
    w18?: number | undefined;
    w19?: number | undefined;
    w20?: number | undefined;
    w21?: number | undefined;
    w22?: number | undefined;
    w23?: number | undefined;
    w24?: number | undefined;
    w25?: number | undefined;
    w26?: number | undefined;
    w27?: number | undefined;
    w28?: number | undefined;
    w29?: number | undefined;
    w30?: number | undefined;
    w31?: number | undefined;
    w32?: number | undefined;
    w33?: number | undefined;
    w34?: number | undefined;
    w35?: number | undefined;
    w36?: number | undefined;
    w37?: number | undefined;
    w38?: number | undefined;
    w39?: number | undefined;
    w40?: number | undefined;
    w41?: number | undefined;
    w42?: number | undefined;
    w43?: number | undefined;
    w44?: number | undefined;
    w45?: number | undefined;
    w46?: number | undefined;
    w47?: number | undefined;
    w48?: number | undefined;
    w49?: number | undefined;
    w50?: number | undefined;
    w51?: number | undefined;
    w52?: number | undefined;
    w53?: number | undefined;
}

export class CreateRollingContractDto implements ICreateRollingContractDto {
    opportunityName!: string;
    teamId!: number;
    year!: string;
    projectId?: string | undefined;
    employeeId?: number | undefined;
    confidenceId!: number;

    constructor(data?: ICreateRollingContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityName = _data["opportunityName"];
            this.teamId = _data["teamId"];
            this.year = _data["year"];
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
            this.confidenceId = _data["confidenceId"];
        }
    }

    static fromJS(data: any): CreateRollingContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRollingContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityName"] = this.opportunityName;
        data["teamId"] = this.teamId;
        data["year"] = this.year;
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        data["confidenceId"] = this.confidenceId;
        return data;
    }
}

export interface ICreateRollingContractDto {
    opportunityName: string;
    teamId: number;
    year: string;
    projectId?: string | undefined;
    employeeId?: number | undefined;
    confidenceId: number;
}

export class TeamDto implements ITeamDto {
    id!: number;
    name?: string | undefined;
    fullSymbol?: string | undefined;
    shortSymbol?: string | undefined;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullSymbol = _data["fullSymbol"];
            this.shortSymbol = _data["shortSymbol"];
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullSymbol"] = this.fullSymbol;
        data["shortSymbol"] = this.shortSymbol;
        return data;
    }
}

export interface ITeamDto {
    id: number;
    name?: string | undefined;
    fullSymbol?: string | undefined;
    shortSymbol?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}